/**
 * Truthful subscription plan labels for paid-launch UI.
 * Unpaid accounts must not be shown as "Free" / "Free Creator".
 */

export function hasActivePaidPlan(args: {
  plan: string | null | undefined;
  stripeSubscriptionId?: string | null | undefined;
  status?: string | null | undefined;
}): boolean {
  const plan = args.plan;
  const subId = (args.stripeSubscriptionId ?? '').trim();
  const status = args.status;
  if (plan !== 'creator' && plan !== 'studio') return false;
  if (!subId) return false;
  return status === 'active' || status === 'trialing';
}

/** Short label for badges and profile lines. */
export function planDisplayLabel(args: {
  plan: string | null | undefined;
  stripeSubscriptionId?: string | null | undefined;
  status?: string | null | undefined;
}): string {
  if (!hasActivePaidPlan(args)) return 'No active plan';
  if (args.plan === 'studio') return 'Studio';
  return 'Creator';
}

/** Label already including “plan” where appropriate (avoids “No active plan plan”). */
export function planDisplayLabelWithPlanSuffix(args: {
  plan: string | null | undefined;
  stripeSubscriptionId?: string | null | undefined;
  status?: string | null | undefined;
}): string {
  if (!hasActivePaidPlan(args)) return 'No active plan';
  if (args.plan === 'studio') return 'Studio plan';
  return 'Creator plan';
}
